import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  dropdown: {
  },
  dropdownCont:{
    paddingTop: "6px",
    paddingBottom: "6px",
  },
}));

export default useStyles;
